let token = '';

export const useToken = () => {
  const setUserToken = (_token: string) => {
    token = _token;
  };

  const getUserToken = () => {
    return token;
  };

  return {
    setUserToken,
    getUserToken
  };
};
